import { z } from 'zod';

import { PrimaryKeySchema, commaDelimitedList } from './utils';

export const ResearchRequestEvidenceSchema = z.object({
  researchRequestEvidenceId: PrimaryKeySchema,
  researchRequestId: PrimaryKeySchema,
  evidence: z.string(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type ResearchRequestEvidence = z.infer<
  typeof ResearchRequestEvidenceSchema
>;

export const ResearchRequestEvidencesSchema = z.array(
  ResearchRequestEvidenceSchema,
);

export type ResearchRequestEvidences = z.infer<
  typeof ResearchRequestEvidencesSchema
>;

export const ResearchRequestEvidenceQuerySchema = z.object({
  researchRequestIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
  researchRequestEvidenceIds: commaDelimitedList(
    PrimaryKeySchema.array(),
  ).optional(),
  researchRequestHypothesisIds: commaDelimitedList(
    PrimaryKeySchema.array(),
  ).optional(),
});

export type ResearchRequestEvidenceQuery = z.infer<
  typeof ResearchRequestEvidenceQuerySchema
>;

export const CreateResearchRequestEvidenceSchema = z.object({
  researchRequestHypothesisId: PrimaryKeySchema,
  evidence: z.string(),
  sourceIds: commaDelimitedList(PrimaryKeySchema.array()),
});

export type CreateResearchRequestEvidence = z.infer<
  typeof CreateResearchRequestEvidenceSchema
>;
